const footer = {
  listStyle: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  margin: '12px 48px',
  padding: 0,
}

const galleryContainer = {
  width: '499px',
  minHeight: '250px',
  maxHeight: '500px',
  overflow: 'hidden',
}

const previewWrapper = {
  paddingBottom: '12px',
}

const singleAsset = {
  width: '500px',
  border: '1px solid white',
}

const styles = {
  footer,
  galleryContainer,
  previewWrapper,
  singleAsset,
}

export { styles }
